<template>
  <div v-if="isAttributesVisible" class="menu-item-attributes m-b-10">
    <item-attribute v-for="(attribute, index) in getAttributes" :key="index" :index="index" :menu-attribute="attribute">
    </item-attribute>
  </div>
</template>

<script>
import ItemAttribute from "./ItemAttribute";
import { sortAttributes } from "@/utils";

export default {
  name: "MenuItemAttributes",
  components: { ItemAttribute },
  props: {
    menuItem: Object
  },
  computed: {
    isAttributesVisible() {
      return this.menuItem.itemAttributes && this.menuItem.itemAttributes.length;
    },
    getAttributes() {
      return [...this.menuItem.itemAttributes].sort(sortAttributes);
    }
  }
};
</script>

<style scoped lang="scss">
.menu-item-attributes {
  display: flex;
  flex-wrap: wrap;
}
</style>
